import { QRCodeSVG } from 'qrcode.react';
import { resolvePortalAccessUrl } from '../lib/portalAccessUrl';

interface LivingRoomQrModalProps {
  titleId: string;
  onClose: () => void;
}

export default function LivingRoomQrModal({
  titleId,
  onClose,
}: LivingRoomQrModalProps) {
  const portalUrl = resolvePortalAccessUrl();

  return (
    <div
      className="living-room-qr-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onClick={onClose}
    >
      <div
        className="living-room-qr-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id={titleId} className="section-header">
          QR code to launch a desktop/homepage AI APP icon
        </h2>
        <p className="living-room-qr-url">{portalUrl}</p>
        <div className="living-room-qr-code-wrap" aria-hidden="true">
          <QRCodeSVG
            value={portalUrl}
            size={220}
            level="M"
            bgColor="#ffffff"
            fgColor="#000000"
            includeMargin
          />
        </div>
        <button type="button" className="btn-primary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
